export enum EmailImageTypeEnum {
    BANNER = 'BANNER',
    LOGO = 'LOGO'
}
